import { memo } from 'react';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading } from '@library';
import type { ProductVehicle } from '../../../types';
import styles from './ProductVariantsTable.module.scss';
import VehiclesTable from './VehiclesTable';
export const TableHeadCellTitle = memo(
    ({
        messageId,
        children,
        normalText,
    }: {
        messageId?: string;
        children?: ReactNode;
        normalText?: boolean;
    }) => (
        <Heading h6 medium uppercase={!normalText}>
            <span className={styles.tableHeadCellTitle}>
                {children || <FormattedMessage id={messageId} />}
            </span>
        </Heading>
    )
);

const ProductCompatibilityTable = ({
    vehicles,
    onModelChange,
}: {
    vehicles: ProductVehicle[];
    onModelChange: (vehicleId: string) => void;
}) => {
    const showTypeColumn = vehicles.some(
        vehicle => !!vehicle.typeNumbers.length
    );

    return (
        <VehiclesTable
            showTypeColumn={showTypeColumn}
            isProductCompatibilityTable
            vehicles={vehicles}
            onModelChange={onModelChange}
        />
    );
};

export default memo(ProductCompatibilityTable);
